/**
 * admin feature routes — owned by web-admin.
 * The pathless "adminFeature" route is registered once in src/app/router.tsx (frozen).
 *   /admin                         tournaments of my tenants
 *   /admin/new                     tournament creation wizard
 *   /admin/courses                 tenant courses (+ /admin/courses/$courseId editor, "new")
 *   /admin/t/$tournamentId?tab=…   tournament console
 *   /admin/t/$tournamentId/ceremony award ceremony presenter
 *   /admin/tenants/$tenantId       organisation profile + staff accounts + statements (TA)
 *   /admin/tenants/$tenantId/players?profile=…  player directory: history, stats, merge (SA)
 *   /a/$adminToken                 ADMIN_CONSOLE share link → login → console
 */
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { rootRoute } from '../../app/root-route';

export const adminFeature = createRoute({ getParentRoute: () => rootRoute, id: 'admin' });

export const adminHomeRoute = createRoute({
  getParentRoute: () => adminFeature,
  path: '/admin',
  component: lazyRouteComponent(() => import('./pages/AdminHomePage'), 'AdminHomePage'),
});

export const adminCreateRoute = createRoute({
  getParentRoute: () => adminFeature,
  path: '/admin/new',
  component: lazyRouteComponent(
    () => import('./pages/CreateTournamentPage'),
    'CreateTournamentPage',
  ),
});

export const adminCoursesRoute = createRoute({
  getParentRoute: () => adminFeature,
  path: '/admin/courses',
  component: lazyRouteComponent(() => import('./pages/CoursesPage'), 'CoursesPage'),
});

export const adminCourseRoute = createRoute({
  getParentRoute: () => adminFeature,
  path: '/admin/courses/$courseId',
  component: lazyRouteComponent(() => import('./pages/CourseEditorPage'), 'CourseEditorPage'),
});

export const adminTournamentRoute = createRoute({
  getParentRoute: () => adminFeature,
  path: '/admin/t/$tournamentId',
  component: lazyRouteComponent(
    () => import('./pages/TournamentConsolePage'),
    'TournamentConsolePage',
  ),
});

/** award ceremony presenter (§15 #478): slides follow on /t/:token/ceremony and the TV */
export const adminCeremonyRoute = createRoute({
  getParentRoute: () => adminFeature,
  path: '/admin/t/$tournamentId/ceremony',
  component: lazyRouteComponent(
    () => import('./pages/CeremonyPresenterPage'),
    'CeremonyPresenterPage',
  ),
});

export const adminTenantRoute = createRoute({
  getParentRoute: () => adminFeature,
  path: '/admin/tenants/$tenantId',
  component: lazyRouteComponent(() => import('./pages/TenantPage'), 'TenantPage'),
});

export const adminPlayersRoute = createRoute({
  getParentRoute: () => adminFeature,
  path: '/admin/tenants/$tenantId/players',
  component: lazyRouteComponent(() => import('./pages/PlayersPage'), 'PlayersPage'),
});

export const adminLinkRoute = createRoute({
  getParentRoute: () => adminFeature,
  path: '/a/$adminToken',
  component: lazyRouteComponent(() => import('./pages/AdminLinkPage'), 'AdminLinkPage'),
});

export const adminRouteTree = adminFeature.addChildren([
  adminHomeRoute,
  adminCreateRoute,
  adminCoursesRoute,
  adminCourseRoute,
  adminTournamentRoute,
  adminCeremonyRoute,
  adminTenantRoute,
  adminPlayersRoute,
  adminLinkRoute,
]);
